import { DEV } from 'esm-env';
import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';

const middlewareEnhancer = applyMiddleware(thunk);

const composeWithDevTools: typeof compose =
  // eslint-disable-next-line no-underscore-dangle
  (DEV && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const composedEnhancers = composeWithDevTools(middlewareEnhancer);

export const createReduxStore: typeof createStore = (rootReducer: any, initialState: any) =>
  createStore(rootReducer, initialState, composedEnhancers);
